import styled from 'styled-components'

export const FeatureConfigurationWrapper = styled.div`
  border: 3px dashed #f0f0f0;
  margin: 10px;
  padding: 10px;
`
